import styled, { css } from 'styled-components'

import { FormGroup } from '../../../components/Form/styles'
import { Wrapper } from '../../../components/Tooltip/styles'
import { RadioStyles, RadioStylesOrigem } from '../../../styles/radio'

export const TermsWrapper = styled.div`
  margin-top: 10px;

  ${({ theme }) => css`
    @media (max-width: ${theme.media.ipad}) {
      &.last-element {
        margin-bottom: 180px;
      }
    }

    @media (max-width: ${theme.media.cel}) {
      &.last-element {
        margin-bottom: 180px;
      }
    }
  `}

  ${FormGroup} {
    margin-bottom: 10px;
    display: flex;
    align-items: center;

    label {
      margin-bottom: 0;
      margin-left: 10px;
    }

    a {
      font-weight: 600;
    }

    ${Wrapper} {
      top: 10px;
    }
  }
`
export const LabelInfo = styled.div`
  font-weight: 500;
  font-size: 16px;
  margin-left: 10px;
  @media (max-width: 720px) {
    text-align: center;
    font-size: 14px;
    margin-left: 0px;
  }
`
export const ErrorList = styled.ul`
  font-size: 14px;
  margin: 0px 0px 10px 10px;

  ${({ theme }) => css`
    @media (max-width: ${theme.media.ipad}) {
      margin-top: -120px;
    }

    @media (max-width: ${theme.media.cel}) {
      margin-top: -180px;
      font-size: 12px;
    }
  `};
`
export const TitleErrorList = styled.h3`
  color: #3d3d3d;
  font-size: 15px;
  font-weight: 500;
  margin: 10px 0px;
`

export const Error = styled.li`
  ${({ theme, isValid, isPasswordEmpty }) => css`
    color: ${isPasswordEmpty ? '#616161' : isValid ? '#5CC187' : '#D22630'};
    display: flex;
    font-weight: 400;
    align-items: center;
    margin: 10px 0;

    &::before {
      content: '${isPasswordEmpty ? '\u25cf' : isValid ? '\u2714' : '\u25cf'}';
      font-size: 14px;
      padding-right: 10px;
      height: 16px;
      width: 20px;
      color: ${isPasswordEmpty ? '#D22630' : isValid ? '#5CC187' : '#D22630'};
      display: inline-block;
    }
  `}
`

export const CaptchaContainer = styled.div`
  margin-bottom: 16px;
`
export const RadioGroup = styled.div`
  ${(props) => RadioStylesOrigem(props.theme)}
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1px 30px;
  width: 100%;
  justify-content: stretch;

  .radio-option {
    display: flex;
    gap: 5px;
  }

  input[type='radio'] {
    margin: 0;
    cursor: pointer;
  }

  label {
    vertical-align: middle;
    line-height: 1;
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`
